'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/bee-overlay/build/trigger/index.js
// module id = 124
// module chunks = 0